import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { OfferDetails } from "@features/AccountDetails/OfferDetails";
import { AccountDetailsMenu } from "@features/AccountDetails/AccountDetailsMenu";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useAccountDetailsPage } from "./useAccountDetailsPage";
import { useStyle } from "./style";
import { EDomain } from "./interface/IAccountDetailsPage";
import { SectionTitle } from "@common/SectionTitle/SectionTitle";

export const AccountDetailsPage = () => {
    const { t } = useTranslation(["navigation", "accountDetails"]);
    const { account, accountDetails, hasMobileSubscriptions, isLoading } = useAccountDetailsPage();
    const { classes } = useStyle();

    return (
        <>
            <SubNavigation />
            <div className="container-boxed">
                <Stack spacing={2}>
                    <HandleErrorAndLoading hideComponentWrapper isLoading={isLoading}>
                        <SectionTitle
                            subtitle={t("accountDetails:accountIdText", { accountId: account?.id })}
                            title={t("navigation:accountDetails")}
                        />
                        <Grid className={classes.container} container direction="column" rowSpacing={8}>
                            {hasMobileSubscriptions || accountDetails?.broadbandSubscription ? (
                                <>
                                    {accountDetails?.mobileSubscriptions.map((mobileSubscription) => (
                                        <Grid item key={mobileSubscription.service.id}>
                                            <OfferDetails domain={EDomain.MOBILE} subscription={mobileSubscription} />
                                        </Grid>
                                    ))}
                                    {accountDetails?.broadbandSubscription && (
                                        <Grid item>
                                            <OfferDetails
                                                domain={EDomain.FIBER}
                                                subscription={accountDetails.broadbandSubscription}
                                            />
                                        </Grid>
                                    )}
                                </>
                            ) : (
                                <Grid item>
                                    <Card elevation={2}>
                                        <CardContent>
                                            <Typography align="center" color="secondary" gutterBottom variant="h4">
                                                {t("accountDetails:noActiveOffer")}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                            <Grid item marginTop={2}>
                                <AccountDetailsMenu
                                    broadbandSubscription={accountDetails?.broadbandSubscription}
                                    hasActiveOfferDetails={hasMobileSubscriptions}
                                />
                            </Grid>
                        </Grid>
                    </HandleErrorAndLoading>
                </Stack>
            </div>
        </>
    );
};
